import httpManager from "@/app/shared/utils/httpManager";

export async function updateCompanyDataAdmin(data) {
  const response = await httpManager.put("/settings/customer/admin/", data);
  return response.data;
}
